import { render, staticRenderFns } from "./VmDialogSubTitle.vue?vue&type=template&id=3ca99529&scoped=true&"
import script from "./VmDialogSubTitle.vue?vue&type=script&lang=js&"
export * from "./VmDialogSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./VmDialogSubTitle.vue?vue&type=style&index=0&id=3ca99529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca99529",
  null
  
)

export default component.exports